import { useQuery } from "@apollo/client";
import Alert from "@mui/material/Alert";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { CupaPreferenceList } from "components/CupaPreferences/CupaPreferenceList";
import { GET_CUPA_PREFERENCE_PROFILE } from "hooks/useCupaPreferenceProfile";
import { Link as RouterLink } from "react-router-dom";

export function CupaPreferencePlaybook({
  facilityState,
  cupaCode,
}: {
  facilityState?: string | null;
  cupaCode?: string | null;
}) {
  const isCA = facilityState === "CA";
  const { data } = useQuery(GET_CUPA_PREFERENCE_PROFILE, {
    variables: { cupaCode: cupaCode ?? "" },
    skip: !isCA || !cupaCode,
    fetchPolicy: "cache-and-network",
  });
  const profile = data?.cupaPreferenceProfile;
  if (!isCA || !cupaCode || !profile) return null;

  return (
    <Alert severity="info" icon={false} sx={{ p: 2 }}>
      <Stack spacing={1.5}>
        <Typography variant="h6">CUPA preferences</Typography>
        {profile.summary && <Typography variant="body2">{profile.summary}</Typography>}
        <CupaPreferenceList preferences={profile.preferences} max={3} />
        <Link component={RouterLink} to={`/staff/cers/cupas/${cupaCode}`}>
          View full playbook →
        </Link>
      </Stack>
    </Alert>
  );
}
